import { useEffect, useState } from 'react'
import { CurrencyContext } from './Context';

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(null);
  useEffect(()=>{
    localStorage.setItem('currency', currency);
  },[currency])
  useEffect(() => {
    const getCurrency = async () => {
      try {
        const res = await fetch('/api/getCurrency.php');
        const currencyData = await res.json();

        if (currencyData.status !== 'success') {
          setCurrency('usd');
          return;
        }
        if (currencyData.currency) {
          setCurrency(currencyData.currency);
        } else {
          setCurrency('usd');
          return;
        }
      } catch (err) {
        console.error('Error determining currency:', err);
        setCurrency('usd');
      }
    };
    
    getCurrency();
  }, []);

  return (
    <CurrencyContext.Provider value={{currency, setCurrency}}>
      {children}
    </CurrencyContext.Provider>
  );
};
